module.exports = __webpack_public_path__ + "static/media/boltonCapital.d777600b.png";